import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import {
    CompanyView,
    OpportunityCompanyClient,
    OpportunityCompanyViewPaginatedResultDto,
    SearchAvailableOpportunityCompaniesParameters,
    SearchCompaniesForOpportunityParameters
} from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class OpportunityCompanyService {
    constructor(private readonly client: OpportunityCompanyClient) {}

    async search(body: SearchCompaniesForOpportunityParameters): Promise<OpportunityCompanyViewPaginatedResultDto> {
        return await lastValueFrom(this.client.opportunityCompanySearchForOpportunity(body));
    }

    async searchAvailable(body: SearchAvailableOpportunityCompaniesParameters): Promise<CompanyView[]> {
        return await lastValueFrom(this.client.opportunityCompanySearchAvailable(body));
    }

    async delete(id: number): Promise<void> {
        return await lastValueFrom(this.client.opportunityCompanyDelete(id));
    }
}
